// Mock data for Space Specialists website

export const businessInfo = {
  name: "Space Specialists",
  tagline: "Transform Your Cluttered Garage Into An Organized Space",
  phone: "(226) 377-7872",
  phoneRaw: "2263777872",
  email: "info@spacespecialistsca.com",
  website: "spacespecialistsca.com",
  location: "London, Ontario, Canada",
  hours: "Mon-Sat: 8:00 AM - 6:00 PM",
  serviceArea: "Serving London, Ontario and surrounding areas"
};

export const packages = [
  {
    id: "bronze",
    name: "Bronze",
    subtitle: "Basic Cleanout",
    price: "$299-$399",
    perfectFor: "Minimal clutter, single-car garage, light organization needed",
    includes: [
      "Removal of all unwanted items (up to 1/2 truckload)",
      "Basic sweeping of cleared areas",
      "Sorting into: Keep/Donate/Dispose",
      "Hauling away of disposal items",
      "Delivery of donations to one local charity",
      "2 hours of service with 2-person crew"
    ],
    addOns: [
      "Additional hour: $75",
      "Extra sweeping/cleaning: $50",
      "Electronics disposal: $25/item",
      "Hazardous material handling: $50"
    ],
    popular: false
  },
  {
    id: "silver",
    name: "Silver",
    subtitle: "Standard Organization",
    price: "$499-$699",
    perfectFor: "Moderate clutter, 1-2 car garage, needs basic systems",
    includes: [
      "Everything in Bronze package",
      "Up to 3/4 truckload removal",
      "Installation of basic shelving (up to 8 feet, provided by client)",
      "Organization of 'keep' items into categories",
      "Labeling of bins/boxes",
      "Sweeping and light cleaning of entire floor",
      "Delivery to donation/recycling centers",
      "4 hours of service with 2-person crew"
    ],
    addOns: [
      "Shelving installation (materials provided by us): $150+",
      "Pegboard installation: $75",
      "Heavy item surcharge: $50/item over 50 lbs"
    ],
    popular: true
  },
  {
    id: "gold",
    name: "Gold",
    subtitle: "Complete Transformation",
    price: "$899-$1,299",
    perfectFor: "Heavy clutter, 2+ car garage, wants full organization system",
    includes: [
      "Everything in Silver package",
      "Full truckload removal capacity",
      "Deep cleaning: sweeping, debris removal, cobweb clearing",
      "Professional organizing consultation",
      "Basic shelving system (materials extra)",
      "Zone creation (gardening, sports, tools, seasonal)",
      "Hazardous material identification and proper disposal",
      "Electronics and appliance removal included",
      "Digital inventory of valuable kept items",
      "6-8 hours with 3-person crew",
      "30-day follow-up check-in"
    ],
    addOns: [
      "Custom shelving/cabinetry: Quote provided",
      "Floor coating/painting: Partner referral",
      "Lighting installation: Partner referral",
      "3-month maintenance visit: $199"
    ],
    popular: false
  },
  {
    id: "platinum",
    name: "Platinum",
    subtitle: "Premium Cleanout + Organization",
    price: "$1,500-$2,500+",
    perfectFor: "Estate situations, hoarding tendencies, complete garage makeovers",
    includes: [
      "Everything in Gold package",
      "Multi-day service available",
      "Specialized crew trained for sensitive situations",
      "Complete inventory and documentation",
      "Professional photography of items for estate/insurance",
      "Coordination with auction houses or consignment shops",
      "Heavy equipment for large items (tractor, extra manpower)",
      "Post-cleanout sanitization/odor treatment",
      "Custom storage solutions design and installation",
      "3D layout planning",
      "6-month maintenance follow-up"
    ],
    addOns: [
      "Same-day dumpster delivery/removal",
      "Structural cleaning (walls, ceilings)",
      "Pest control coordination",
      "Full garage renovation coordination"
    ],
    popular: false
  }
];

export const alacarte = [
  {
    name: "Donation Drop-Off Service Only",
    price: "$150",
    description: "Pick up, sort, and deliver donations (you box/bag). Receipt provided for tax purposes."
  },
  {
    name: "Organizing Only",
    price: "$75/hour",
    description: "Professional organizer will sort, categorize, and create systems. No hauling included."
  },
  {
    name: "Hauling Only",
    price: "$200/truckload + $75/hour labor",
    description: "Minimum 2-hour charge. You sort, we haul."
  },
  {
    name: "Seasonal Rotation",
    price: "$199",
    description: "Switch out seasonal items (holiday decorations, summer/winter gear). Includes cleaning of stored areas."
  },
  {
    name: "Garage Sale Setup",
    price: "$299",
    description: "Pricing, display, signage, cash box setup. 4-hour assistance on sale day. Cleanup/removal of unsold items."
  }
];

export const commercialPackages = [
  {
    name: "Realtor Special: Pre-Listing Cleanout",
    price: "$449",
    description: "Flat rate for standard 2-car garage. 48-hour guaranteed completion. Before/after photos provided. Focus on maximizing showing appeal."
  },
  {
    name: "Property Manager Package",
    price: "Custom Quote",
    description: "Monthly/quarterly maintenance contracts. Bulk pricing for multiple units. 24/7 emergency cleanup availability. Detailed reporting for property owners."
  }
];

export const testimonials = [
  {
    name: "Sarah Thompson",
    location: "London, ON",
    rating: 5,
    text: "Space Specialists transformed my disaster of a garage into an organized space in just one afternoon! The Silver package was perfect for our needs. Highly recommend!",
    package: "Silver Package"
  },
  {
    name: "Michael Chen",
    location: "London, ON",
    rating: 5,
    text: "Professional, efficient, and reasonably priced. They hauled away 20 years of accumulated junk and left my garage spotless. Worth every penny!",
    package: "Gold Package"
  },
  {
    name: "Jennifer Martinez",
    location: "St. Thomas, ON",
    rating: 5,
    text: "We used the Realtor Special before listing our home. The garage looked amazing in photos and helped us sell faster. Thank you!",
    package: "Realtor Special"
  },
  {
    name: "Robert Williams",
    location: "London, ON",
    rating: 5,
    text: "The Platinum package was a game-changer for my late father's estate. They handled everything with care and professionalism during a difficult time.",
    package: "Platinum Package"
  }
];

export const features = [
  {
    icon: "Shield",
    title: "Fully Insured",
    description: "Licensed and insured for your peace of mind"
  },
  {
    icon: "Clock",
    title: "Fast Service",
    description: "Most projects completed in 1-2 days"
  },
  {
    icon: "Recycle",
    title: "Eco-Friendly",
    description: "We donate and recycle whenever possible"
  },
  {
    icon: "Users",
    title: "Professional Crew",
    description: "Background-checked, uniformed staff"
  },
  {
    icon: "DollarSign",
    title: "Transparent Pricing",
    description: "No hidden fees, free estimates"
  },
  {
    icon: "CheckCircle",
    title: "Satisfaction Guaranteed",
    description: "30-day follow-up on Gold/Platinum packages"
  }
];

export const beforeAfter = [
  {
    id: 1,
    before: "https://customer-assets.emergentagent.com/job_garage-revival-1/artifacts/zr7vqfdk_GettyImages-1175908367-74aa05d67c784e819e437a00ba818846.jpg",
    after: "https://customer-assets.emergentagent.com/job_garage-revival-1/artifacts/1a6y0m0x_IMG_1355.JPG",
    package: "Silver Package",
    description: "1-car garage transformation"
  },
  {
    id: 2,
    before: "https://customer-assets.emergentagent.com/job_garage-revival-1/artifacts/djtk79rh_pexels-idzzzed-35069740.jpg",
    after: "https://customer-assets.emergentagent.com/job_garage-revival-1/artifacts/5p09pwrh_pexels-hiroom-17181949.jpg",
    package: "Gold Package",
    description: "2-car garage complete organization"
  },
  {
    id: 3,
    before: "https://customer-assets.emergentagent.com/job_garage-revival-1/artifacts/zr7vqfdk_GettyImages-1175908367-74aa05d67c784e819e437a00ba818846.jpg",
    after: "https://customer-assets.emergentagent.com/job_garage-revival-1/artifacts/hm2w2zvd_pexels-peter-vang-2157328093-34764058.jpg",
    package: "Bronze Package",
    description: "Basic cleanout and sweep"
  }
];

export const faqs = [
  {
    question: "How long does a typical garage cleanout take?",
    answer: "Most cleanouts take 2-8 hours depending on the package. Bronze takes 2 hours, Silver takes 4 hours, Gold takes 6-8 hours, and Platinum can span multiple days for complex projects."
  },
  {
    question: "Do I need to be present during the cleanout?",
    answer: "We recommend being present at the start to point out what to keep, donate, or dispose. For the actual work, you can leave if you prefer, but many clients like to oversee the process."
  },
  {
    question: "What items can't you remove?",
    answer: "We cannot remove certain hazardous materials like paint cans, chemicals, or asbestos without special handling (additional fee). We'll assess during the free estimate."
  },
  {
    question: "Do you provide the organization materials?",
    answer: "Basic services use your existing materials. We can provide and install shelving, bins, and organization systems for an additional fee (included in Gold/Platinum or as add-ons)."
  },
  {
    question: "How do you price your services?",
    answer: "Pricing is based on the volume of items, labor hours, disposal fees, and any special requirements. We provide a free on-site estimate before starting any work."
  },
  {
    question: "What happens to the items you remove?",
    answer: "We donate usable items to local charities, recycle what we can, and properly dispose of the rest at licensed facilities. You'll receive donation receipts for tax purposes."
  }
];
